import { type UseMutationResult, useMutation } from "@tanstack/react-query"
import { AxiosError, type AxiosResponse } from "axios"

import { ELogoutMutationKey } from "@/3514/config"
import { logoutMutator } from "@/3514/mutators"
import { minutes, seconds } from "@/3514/utils/time.utils"
import type { TEmptyAsyncCallback } from "@/shared/types/functions"

type TLogoutMutationPayload = { refresh: string }
type TLogoutMutationResponse = AxiosResponse<-1>
type _TLogoutMutationParams = {
    onError?(err: AxiosError, vars: TLogoutMutationPayload, ctxt: void): Promise<void>
    onSettled?: TEmptyAsyncCallback
}
type TLogoutMutation = UseMutationResult<TLogoutMutationResponse, AxiosError, TLogoutMutationPayload>

function useLogoutMutation(
    params?: _TLogoutMutationParams
): ReturnType<(params: _TLogoutMutationParams) => TLogoutMutation> {
    return useMutation<TLogoutMutationResponse, AxiosError, TLogoutMutationPayload>({
        mutationKey: ELogoutMutationKey(),
        mutationFn: logoutMutator,
        gcTime: minutes(1),
        retry: 1,
        retryDelay: seconds(5),
        networkMode: "offlineFirst",
        throwOnError: false,
        ...params
    })
}

export { useLogoutMutation }
export type { TLogoutMutation, TLogoutMutationPayload, TLogoutMutationResponse }
